import { createAction, props } from '@ngrx/store';

export const updateCatchErrorRestore = createAction(
    '[RESTORE] update catchError Restore',
    props<{ value: boolean }>(),
);
